/* eslint-disable no-restricted-globals */
/* eslint-disable func-names */
/* eslint-disable no-undef */
const share = () => {
  (function ($) {
    const $btn = $('.js-social-share');

    const windowPopup = (url, width, height) => {
      // Calculate the position of the popup so
      // it’s centered on the screen.
      const left = (screen.width / 2) - (width / 2);
      const top = (screen.height / 2) - (height / 2);

      window.open(
        url,
        '',
        `menubar=no,toolbar=no,resizable=yes,scrollbars=yes,width=${width},height=${height},top=${top},left=${left}`,
      );
    };

    $btn.on('click', function (e) {
      e.preventDefault();
      windowPopup($(this).attr('href'), 700, 400);
    });
  }(jQuery));
};

export default share;
